<script>
    export let shadow = ''
    export let border
    export let padding
    $: style = shadow ? `box-shadow: 0 0 ${shadow}px 0 #8c8c8c; ${border} ${padding}` : `${border} ${padding}`
</script>

<div class="component-card component-card-area" {style}>
    <slot />
</div>
